<template>
  <div>
    <div v-if="showSearchIconAppTicketSystem">
      <el-row type="flex" :gutter="6" style="margin-bottom: -20px; position: relative; z-index: 1">
        <el-col :span="4">
          <el-input
              v-model="getAllTicketAppSystemRequest.nameTicket"
              placeholder="Nhập tên phiếu bé ngoan"
              @clear="searchHeaderMethodTicketSystem()"
              clearable
              @keyup.enter.native="searchHeaderMethodTicketSystem()"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="searchHeaderMethodTicketSystem()"
              ></el-button>
            </template>
          </el-input>
        </el-col>

      </el-row>
    </div>
    <div v-if="showSearchIconAppTicket">
      <el-row type="flex" :gutter="6" style="margin-bottom: -20px; position: relative; z-index: 1">
        <el-col :span="5">
          <el-select
              style="width: 100%"
              class="button-left-class_search"
              filterable
              v-model="getAllTicketAppRequest.idSchool"
              placeholder="Chọn trường"
              @change="searchHeaderMethodTicket()"
          >
            <el-option
                v-for="item in schoolList"
                :key="item.id"
                :value="item.id"
                :label="`${item.id} - ${item.schoolName}`"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-input
              v-model="getAllTicketAppRequest.nameTicket"
              style="width: 100%"
              placeholder="Nhập tên phiếu bé ngoan"
              @clear="searchHeaderMethodTicket()"
              clearable
              @keyup.enter.native="searchHeaderMethodTicket()"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="searchHeaderMethodTicket()"
              ></el-button>
            </template>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName" class="wrap_tab">
        <el-tab-pane label='Hệ thống' name="ticketAppSystem">
          <el-table
              ref="multipleTable"
              :empty-text="textTableTemplateSystemAppTab"
              v-loading="loadingDataTemplate"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="ticketAppSystemList"
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeTemplateSystem"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                fixed
                width="80"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="80"
                align="center"
            ></el-table-column>
            <el-table-column
                label="Tên gói"
                min-width="200"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.id }} - {{ scope.row.nameTicket }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Mô tả gói"
                min-width="300"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.descriptionTicket }}</span>
              </template>
            </el-table-column>

            <el-table-column
                label="Phiên bản"
                min-width="150"
                align="center"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.version }}</span>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="Tác vụ"
                width="300"
                align="center"
            >
              <template v-slot:default="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="openDetailTicketSystemAppDialog(scope.row)"
                >Chi tiết
                </el-button>
                <el-button
                    size="mini"
                    type="primary"
                    @click="openUpdateTicketSystemAppDialog(scope.row)"
                >Sửa
                </el-button
                >
                <el-button
                    size="mini"
                    type="danger"
                    @click="deleteTicketSystemAppMethod(scope.row)"
                >Xóa
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-row style="margin-top: 15px">
            <el-col :span="9" :offset="11">
              <el-pagination
                  background
                  style=" margin-right: 5.2rem;margin-left: auto"
                  @size-change="handleSizeChangeTemplateSystem"
                  @current-change="handleCurrentChangeTemplateSytem"
                  :current-page.sync="currentPagePaginationSystem"
                  :page-sizes="$pageListDefaultNew"
                  :page-size="sizeLimitSystem"
                  layout="prev, pager,sizes, next"
                  :total="sizeLimitSystem * totalPagesSystem"
              ></el-pagination>
            </el-col>
            <el-col :span="2" :offset="2" style="display: inline-flex;justify-content: right">
              <el-dropdown @command="handleActionTicketSystem">
                <el-button class="button-over" type="success">
                  Tác vụ
                  <i class="el-icon-caret-bottom"/>
                </el-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="addTicketSystem"
                  >Thêm phiếu bé ngoan
                  </el-dropdown-item
                  >
                  <el-dropdown-item command="deleteManyTicketSystem" v-if="!showSearchIconAppTicketSystem"
                  >Xoá phiếu bé ngoan
                  </el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>


        </el-tab-pane>

        <el-tab-pane label="Nhà trường" name="ticketAppTab">
          <el-table
              ref="multipleTable"
              :empty-text="textTableTemplateAppTab"
              v-loading="loadingDataTemplate"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="ticketAppList"
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeTemplate"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                fixed
                width="80"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="80"
                align="center"
            ></el-table-column>
            <el-table-column
                label="Tên gói"
                min-width="200"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.id }} - {{ scope.row.nameTicket }}</span>
              </template>
            </el-table-column>

            <el-table-column
                label="Mô tả gói"
                min-width="300"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.descriptionTicket }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Nguồn"
                width="200"
                align="center"
            >
              <template v-slot:default="scope">
                <span>{{ formatTypeTicket(scope.row.typeTicket) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="Phiên bản"
                min-width="150"
                align="center"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.version }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Mặc định hệ thống" width="150" align="center">
              <template v-slot:default="scope">
                <el-checkbox
                    @change="setDefaultTicket(scope.row)"
                    v-model="scope.row.defaultTicket"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column
                fixed="right"
                label="Tác vụ"
                width="300"
                align="center"
            >
              <template v-slot:default="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="openDetailTicketAppDialog(scope.row)"
                >Chi tiết
                </el-button>
                <el-button
                    :disabled="scope.row.typeTicket === 'system'"
                    size="mini"
                    type="primary"
                    @click="openUpdateTicketAppDialog(scope.row)"
                >Sửa
                </el-button
                >
                <el-button
                    size="mini"
                    type="danger"
                    @click="deleteTicketAppMethod(scope.row)"
                >Xóa
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-row style="margin-top: 15px">
            <el-col :span="9" :offset="11">
              <el-pagination
                  background
                  style=" margin-right: 5.2rem;margin-left: auto"
                  @size-change="handleSizeChangeTemplate"
                  @current-change="handleCurrentChangeTemplate"
                  :current-page.sync="currentPagePagination"
                  :page-sizes="$pageListDefaultNew"
                  :page-size="sizeLimit"
                  layout="prev, pager,sizes, next"
                  :total="sizeLimit * totalPages"
              ></el-pagination>
            </el-col>
            <el-col :span="2" :offset="2" style="display: inline-flex;justify-content: right">
              <el-dropdown @command="handleActionTicket">
                <el-button class="button-over" type="success">
                  Tác vụ
                  <i class="el-icon-caret-bottom"/>
                </el-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="addTicket"
                  >Thêm phiếu bé ngoan
                  </el-dropdown-item
                  >
                  <el-dropdown-item command="deleteManyTicket"
                  >Xoá phiếu bé ngoan
                  </el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>


        </el-tab-pane>
      </el-tabs>
    </div>

    <!--  Dialog nhà trường  -->
    <DetailTicketAppDialog
        :isOpenDetailTicketAppDialog="showDetailTicketAppDialog"
        @dialog-close="closeDetailTemplateAppDialog()"
        ref="DetailTemplateAppDialog"
    ></DetailTicketAppDialog>

    <UpdateTicketAppDialog
        :isOpenUpdateTicketAppDialog="showUpdateTicketAppDialog"
        @dialog-close="closeUpdateTicketAppDialog()"
        ref="UpdateTicketAppDialog"
    ></UpdateTicketAppDialog>

    <AddTicketAppDialog
        :isOpenAddTicketAppDialog="showAddTicketAppDialog"
        @dialog-close="closeAddTicketAppDialog()"
        ref="addTicketAppDialog"
    ></AddTicketAppDialog>

    <!-- Dialog hệ thống -->
    <AddTicketAppSystemDialog
        :isOpenAddTicketAppDialog="showAddTicketAppDialogSystem"
        @dialog-close="closeAddTicketAppDialogSystem()"
        ref="AddTicketAppSystemDialog"
    />

    <DetailTicketAppSystemDialog
        :isOpenDetailTicketAppDialog="showDetailTicketSystemAppDialog"
        @dialog-close="closeDetailTicketSysAppDialog()"
        ref="DetailTicketAppSystemDialog"
    />

    <UpdateTicketSystemAppDialog
        :isOpenUpdateTicketAppDialog="showUpdateTicketSystemAppDialog"
        @dialog-close="closeUpdateTicketSystemAppDialog()"
        ref="UpdateTicketSystemAppDialog"
    />

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import DetailTicketAppSystemDialog from "@/views/ticketApp/DetailTicketAppSystemDialog.vue";
import SystemConfigTicket from "@/services/AdminService/SystemConfigTicket";
import AddTicketAppSystemDialog from "@/views/ticketApp/AddTicketAppSystemDialog.vue";
import UpdateTicketSystemAppDialog from "@/views/ticketApp/UpdateTicketSystemAppDialog.vue";
import AddTicketAppDialog from "@/views/ticketApp/AddTicketAppDialog.vue";
import DetailTicketAppDialog from "@/views/ticketApp/DetailTicketAppDialog.vue";
import UpdateTicketAppDialog from "@/views/ticketApp/UpdateTicketAppDialog.vue";


export default {
  components: {
    UpdateTicketAppDialog,
    DetailTicketAppDialog,
    AddTicketAppDialog,
    UpdateTicketSystemAppDialog,
    AddTicketAppSystemDialog,
    DetailTicketAppSystemDialog,
  },
  created() {
    this.$store.dispatch('schoolStore/fetchDataAgentList');
  },
  computed: {
    ...mapState('schoolStore', ['agentList']),
    ...mapState('schoolStore', ['schoolList'])
  },
  watch: {
    agentList: {
      immediate: true,
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdAgent();
        }
      },
    },
  },
  data() {
    return {
      sizeLimit: 10,
      sizeLimitSystem: 10,
      totalPages: 0,
      totalPagesSystem: 0,
      currentPagePagination: 1,
      currentPagePaginationSystem: 1,
      activeTabName: "ticketAppSystem",
      loadingData: true,
      showUpdateDialog: false,
      showDetailTicketAppDialog: false,
      showUpdateTicketAppDialog: false,
      showAddTicketAppDialog: false,
      showAddTicketAppDialogSystem: false,
      showDetailTicketSystemAppDialog: false,
      showUpdateTicketSystemAppDialog: false,
      idAgent: "",
      layout: "sizes, prev, pager, next",
      getAllTicketAppRequest: {
        idSchool: 1,
        appType: "",
        nameTicket: "",
        pageNumber: 1,
        pageTotal: this.$pageTotalDefault,
        maxPageItem: 10,
      },
      getAllTicketAppSystemRequest: {
        nameTicket: "",
        pageNumber: 1,
        pageTotal: this.$pageTotalDefault,
        maxPageItem: 10,
      },
      textTableTemplateAppTab: "",
      textTableTemplateSystemAppTab: "",
      ticketAppList: [],
      ticketAppSystemList: [],
      showSearchIconAppTicket: false,
      showSearchIconAppTicketSystem: true,
      multipleSelectionTemplate: [],
      multipleSelectionTemplateSystem: [],
      loadingDataTemplate: true,
    };
  },
  methods: {
    ...mapActions('schoolStore', ["fetchDataSchoolList"]),
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyleDetail({row}) {
      if (
          row.absentStatus === "Nghỉ có phép" ||
          row.absentStatus === "Nghỉ không phép"
      ) {
        return "color: red";
      } else if (row.absentStatus === "Chưa điểm danh") {
        return "color: #409EFF";
      }
    },

    handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "ticketAppTab") {
        this.showSearchIconAppTicket = true;
        this.showSearchIconAppTicketSystem = false;
        this.getAllDataForTicketAppTab()
      } else if (tabNameClick === 'ticketAppSystem') {
        this.showSearchIconAppTicketSystem = true;
        this.showSearchIconAppTicket = false;
        this.getAllDataForTicketAppTabSystem()
      }

    },

    /// Giao diện App

    openDetailTicketAppDialog(row) {
      this.showDetailTicketAppDialog = true;
      const selectedSchool = this.schoolList.find(item => item.id === row.idSchool);
      let nameSchool = selectedSchool.schoolName;
      this.$refs.DetailTemplateAppDialog.getDataInitialDetailTemplateAppDialog(nameSchool, row);
    },

    openDetailTicketSystemAppDialog(row) {
      this.showDetailTicketSystemAppDialog = true;
      this.$refs.DetailTicketAppSystemDialog.getDataInitialDetailTicketAppDialog(row.id);
    },
    closeDetailTemplateAppDialog() {
      this.showDetailTicketAppDialog = false;
    },
    closeDetailTicketSysAppDialog() {
      this.showDetailTicketSystemAppDialog = false;
    },

    openAddTicketAppDialog() {
      this.showAddTicketAppDialog = true;
      this.$refs.addTicketAppDialog.setDefaultSchool(this.getAllTicketAppRequest.idSchool);
    },

    openAddTicketAppDialogSystem() {
      this.showAddTicketAppDialogSystem = true;
    },

    closeAddTicketAppDialog() {
      this.showAddTicketAppDialog = false;
      this.getAllDataForTicketAppTab();
    },

    closeAddTicketAppDialogSystem() {
      this.showAddTicketAppDialogSystem = false;
      this.getAllDataForTicketAppTabSystem();
    },

    openUpdateTicketAppDialog(row) {
      this.showUpdateTicketAppDialog = true;
      const selectedSchool = this.schoolList.find(item => item.id === row.idSchool);
      let nameSchool = selectedSchool.schoolName;
      this.$refs.UpdateTicketAppDialog.getDataInitialUpdateTicketDialog(nameSchool, row);
    },
    async openUpdateTicketSystemAppDialog(row) {
      await this.$refs.UpdateTicketSystemAppDialog.getDataInitialUpdateTicketDialog(row);
      this.showUpdateTicketSystemAppDialog = true;
    },
    closeUpdateTicketAppDialog() {
      this.showUpdateTicketAppDialog = false;
      this.getAllDataForTicketAppTab();
    },
    closeUpdateTicketSystemAppDialog() {
      this.showUpdateTicketSystemAppDialog = false;
      this.getAllDataForTicketAppTabSystem();
    },

    handleActionTicket(command) {
      if (command === "addTicket") {
        this.openAddTicketAppDialog();
      } else if (command === "deleteManyTicket") {
        this.deleteOneOrManyTemplate()
      }
    },
    handleActionTicketSystem(command) {
      if (command === "addTicketSystem") {
        this.openAddTicketAppDialogSystem();
      } else if (command === "deleteManyTicketSystem") {
        this.deleteOneOrManyTemplate()
      }
    },
    handleSelectionChangeTemplate(val) {
      this.multipleSelectionTemplate = val;
    },
    handleSelectionChangeTemplateSystem(val) {
      this.multipleSelectionTemplateSystem = val;
    },
    getAllDataForTicketAppTab() {
      this.ticketAppList = [];
      this.loadingDataTemplate = true;
      let idSchool = this.getAllTicketAppRequest.idSchool;
      let appType = this.getAllTicketAppRequest.appType;
      let nameTicket = this.getAllTicketAppRequest.nameTicket;
      let pageNumber = this.getAllTicketAppRequest.pageNumber;
      let maxPageItem = this.getAllTicketAppRequest.maxPageItem;
      SystemConfigTicket.getListTicket(idSchool, nameTicket, pageNumber, maxPageItem, appType)
          .then((resp) => {
            this.ticketAppList = resp.data.data.listTicket;
            this.loadingDataTemplate = false;
            this.totalPages = Math.floor(resp.data.data.total / this.sizeLimit);
            if ((resp.data.data.total % this.sizeLimit) !== 0) {
              this.totalPages = this.totalPages + 1
            }
          })
          .catch((err) => {
            this.pageTotal = 1;
            this.ticketAppList = [];
            this.loadingDataTemplate = false;
            console.log(err);
          })
          .finally(() => {
            if (this.ticketAppList.length === 0) {
              this.textTableTemplateAppTab = this.$tableEmpty;
            }
            this.loadingDataTemplate = false;
          });
    },

    getAllDataForTicketAppTabSystem() {
      this.ticketAppSystemList = [];
      this.loadingDataTemplate = true;
      const nameTicket = this.getAllTicketAppSystemRequest.nameTicket;
      const pageNumber = this.getAllTicketAppSystemRequest.pageNumber;
      const maxPageItem = this.getAllTicketAppSystemRequest.maxPageItem;
      SystemConfigTicket.getListTemplateSystem(1, nameTicket, pageNumber, maxPageItem)
          .then((resp) => {
            this.ticketAppSystemList = resp.data.data.listTicket;
            this.loadingDataTemplate = false;
            this.totalPagesSystem = Math.floor(resp.data.data.total / this.sizeLimit);
            if ((resp.data.data.total % this.sizeLimitSystem) !== 0) {
              this.totalPagesSystem = this.totalPagesSystem + 1
            }
          })
          .catch((err) => {
            this.pageTotal = 1;
            this.ticketAppSystemList = [];
            this.loadingDataTemplate = false;
            console.log(err);
          })
          .finally(() => {
            if (this.ticketAppSystemList.length === 0) {
              this.textTableTemplateSystemAppTab = this.$tableEmpty;
            }
            this.loadingDataTemplate = false;
          });
    },

    handleSizeChangeTemplate(value) {
      this.sizeLimit = value;
      this.getAllTicketAppRequest.maxPageItem = value;
      this.getAllDataForTicketAppTab();
    },
    handleSizeChangeTemplateSystem(value) {
      this.sizeLimitSystem = value;
      this.getAllTicketAppSystemRequest.maxPageItem = value;
      this.getAllDataForTicketAppTabSystem();
    },
    handleCurrentChangeTemplate(value) {
      this.currentPagePagination = value
      this.getAllTicketAppRequest.pageNumber = value;
      this.getAllDataForTicketAppTab();
    },
    handleCurrentChangeTemplateSytem(value) {
      this.currentPagePaginationSystem = value
      this.getAllTicketAppSystemRequest.pageNumber = value;
      this.getAllDataForTicketAppTabSystem();
    },
    searchHeaderMethodTicket() {
      this.pageNumber = 1;
      this.getAllDataForTicketAppTab();
    },

    searchHeaderMethodTicketSystem() {
      this.pageNumber = 1;
      this.getAllDataForTicketAppTabSystem();
    },


    /**
     * danh sách đại lý
     */
    getIdAgent() {
      this.idAgent = this.agentList[0].id;
      this.fetchDataSchoolList(this.idAgent);
      this.getAllDataForTicketAppTab()
      this.getAllDataForTicketAppTabSystem()
    },

    /**
     * Xoá 1 template
     */

    deleteTicketAppMethod(row) {

      this.$confirm(`Xác nhận xóa "${row.id} - ${row.nameTicket}" ?`, 'Cảnh báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
        type: 'warning'
      }).then(() => {
        SystemConfigTicket.deleteTicketAppSchool(row.id).then((res) => {
          this.$message({
            type: 'success',
            message: res.data.message
          });
          this.getAllDataForTicketAppTab()
          this.closeDialog()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy thao tác'
        });
      });
    },
    deleteTicketSystemAppMethod(row) {
      let id = row.id
      this.$confirm(`Xác nhận xóa "${row.id} - ${row.nameTicket}"?`, 'Cảnh báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
        type: 'warning'
      }).then(() => {
        SystemConfigTicket.deleteTicketAppSystem(id)
            .then((res) => {
              this.$message({
                type: 'success',
                message: res.data.message
              });
              this.getAllDataForTicketAppTabSystem()
              this.closeDialog()
            })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy thao tác'
        });
      });
    },

    /**
     * Xoá 1 hoặc nhiều Template
     */
    deleteOneOrManyTemplate() {
      let idTemplateList = this.multipleSelectionTemplate.map(x => x.id);
      this.checkSelectBeforeHandleFunction(idTemplateList);
      this.$confirm('Xác nhận xóa các phiếu bé ngoan đã chọn ?', 'Cảnh báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
        type: 'warning'
      }).then(() => {
        SystemConfigTicket.deleteMultiTicket(idTemplateList).then((res) => {
          this.$message({
            type: 'success',
            message: res.data.message
          });
          this.getAllDataForTicketAppTab()
          this.closeDialog()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy thao tác'
        });
      });
    },

    checkSelectBeforeHandleFunction() {
      let selectRowList = this.multipleSelectionTemplate.map((x) => x.id);
      if (selectRowList.length === 0) {
        this.$message({
          message: "Bạn chưa chọn gói nào",
          type: "error",
        });
        throw null;
      }
    },

    setDefaultTicket(row) {
      this.loadingDataTemplate = true;
      SystemConfigTicket.setDefaultTicketAppSystem(row.id)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
            this.getAllDataForTicketAppTab()
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingDataTemplate = false;
            }, 500);
          });
    },

    formatTypeTicket(type) {
      switch (type) {
        case "system":
          return "Hệ thống";
        case "school":
          return "Nhà trường";
      }
    }
  },

};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

/deep/ .el-table .cell {
  white-space: pre-line;
  line-height: 20px;
  word-break: break-word;
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

  // display: inline-block;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

// .table-header {
//   position: sticky;
// }
// table{

// }
thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
  // display: block;
  // width: 90%;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  // height: 600px;
  font-family: Arial, Helvetica, sans-serif;
  // display: block;
  // width: 90%;
}

td {
  padding: 12px;
}

.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.button-left-class_search {
  margin-right: 5px;
  width: 150px;
}
</style>